/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { ApiInvestissements } from "../model"
// @ts-ignore
import type { UpdateInvestissementsRequest } from "../model"
/**
 * InvestissementsResourceApi - axios parameter creator
 */
export const InvestissementsResourceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Delete investissement by note id
     * @param {string} structureId corresponds to noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvestissements: async (
      structureId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'structureId' is not null or undefined
      assertParamExists("deleteInvestissements", "structureId", structureId)
      const localVarPath = `/investissements/{structureId}`.replace(
        "{structureId}",
        encodeURIComponent(String(structureId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get investissements by note id
     * @param {string} structureId corresponds to noteId
     * @param {boolean} [purchaseDateComputing] compute default purchase date on amortization lines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvestissements: async (
      structureId: string,
      purchaseDateComputing?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'structureId' is not null or undefined
      assertParamExists("getInvestissements", "structureId", structureId)
      const localVarPath = `/investissements/{structureId}`.replace(
        "{structureId}",
        encodeURIComponent(String(structureId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (purchaseDateComputing !== undefined) {
        localVarQueryParameter["purchaseDateComputing"] = purchaseDateComputing
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update investissement
     * @param {string} structureId corresponds to noteId
     * @param {UpdateInvestissementsRequest} updateInvestissementsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvestissements: async (
      structureId: string,
      updateInvestissementsRequest: UpdateInvestissementsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'structureId' is not null or undefined
      assertParamExists("updateInvestissements", "structureId", structureId)
      // verify required parameter 'updateInvestissementsRequest' is not null or undefined
      assertParamExists(
        "updateInvestissements",
        "updateInvestissementsRequest",
        updateInvestissementsRequest
      )
      const localVarPath = `/investissements/{structureId}`.replace(
        "{structureId}",
        encodeURIComponent(String(structureId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateInvestissementsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * InvestissementsResourceApi - functional programming interface
 */
export const InvestissementsResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InvestissementsResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete investissement by note id
     * @param {string} structureId corresponds to noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteInvestissements(
      structureId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvestissements(
        structureId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvestissementsResourceApi.deleteInvestissements"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get investissements by note id
     * @param {string} structureId corresponds to noteId
     * @param {boolean} [purchaseDateComputing] compute default purchase date on amortization lines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvestissements(
      structureId: string,
      purchaseDateComputing?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiInvestissements>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInvestissements(
        structureId,
        purchaseDateComputing,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvestissementsResourceApi.getInvestissements"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update investissement
     * @param {string} structureId corresponds to noteId
     * @param {UpdateInvestissementsRequest} updateInvestissementsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateInvestissements(
      structureId: string,
      updateInvestissementsRequest: UpdateInvestissementsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiInvestissements>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvestissements(
        structureId,
        updateInvestissementsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvestissementsResourceApi.updateInvestissements"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * InvestissementsResourceApi - factory interface
 */
export const InvestissementsResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InvestissementsResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Delete investissement by note id
     * @param {InvestissementsResourceApiDeleteInvestissementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvestissements(
      requestParameters: InvestissementsResourceApiDeleteInvestissementsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .deleteInvestissements(requestParameters.structureId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get investissements by note id
     * @param {InvestissementsResourceApiGetInvestissementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvestissements(
      requestParameters: InvestissementsResourceApiGetInvestissementsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiInvestissements> {
      return localVarFp
        .getInvestissements(
          requestParameters.structureId,
          requestParameters.purchaseDateComputing,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update investissement
     * @param {InvestissementsResourceApiUpdateInvestissementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInvestissements(
      requestParameters: InvestissementsResourceApiUpdateInvestissementsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiInvestissements> {
      return localVarFp
        .updateInvestissements(
          requestParameters.structureId,
          requestParameters.updateInvestissementsRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for deleteInvestissements operation in InvestissementsResourceApi.
 */
export interface InvestissementsResourceApiDeleteInvestissementsRequest {
  /**
   * corresponds to noteId
   */
  readonly structureId: string
}

/**
 * Request parameters for getInvestissements operation in InvestissementsResourceApi.
 */
export interface InvestissementsResourceApiGetInvestissementsRequest {
  /**
   * corresponds to noteId
   */
  readonly structureId: string

  /**
   * compute default purchase date on amortization lines
   */
  readonly purchaseDateComputing?: boolean
}

/**
 * Request parameters for updateInvestissements operation in InvestissementsResourceApi.
 */
export interface InvestissementsResourceApiUpdateInvestissementsRequest {
  /**
   * corresponds to noteId
   */
  readonly structureId: string

  readonly updateInvestissementsRequest: UpdateInvestissementsRequest
}

/**
 * InvestissementsResourceApi - object-oriented interface
 */
export class InvestissementsResourceApi extends BaseAPI {
  /**
   *
   * @summary Delete investissement by note id
   * @param {InvestissementsResourceApiDeleteInvestissementsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteInvestissements(
    requestParameters: InvestissementsResourceApiDeleteInvestissementsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InvestissementsResourceApiFp(this.configuration)
      .deleteInvestissements(requestParameters.structureId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get investissements by note id
   * @param {InvestissementsResourceApiGetInvestissementsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getInvestissements(
    requestParameters: InvestissementsResourceApiGetInvestissementsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InvestissementsResourceApiFp(this.configuration)
      .getInvestissements(
        requestParameters.structureId,
        requestParameters.purchaseDateComputing,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update investissement
   * @param {InvestissementsResourceApiUpdateInvestissementsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateInvestissements(
    requestParameters: InvestissementsResourceApiUpdateInvestissementsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InvestissementsResourceApiFp(this.configuration)
      .updateInvestissements(
        requestParameters.structureId,
        requestParameters.updateInvestissementsRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
